import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './InternalEditScreen';
import InternalEdit from './InternalEditScreen';
import { StoreState } from 'src/store/reducers';
import { getInternal } from 'src/store/actions/internal-actions';
import { getProvidersSmall } from '../../../../../../store/actions/provider-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        internal: state.internals.current,
        providers: state.providers.data,

        inProgress: state.internals.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (id) => dispatch(getInternal(id)),
        getProviders: (params) => dispatch(getProvidersSmall(params)),
    };
}

const InternalEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(InternalEdit);

export default InternalEditScreen;
